import React, { useEffect, useState } from "react";
import { Field } from "formik";
import Topnav from "../../components/topnav/topnav";
import "./currentOrders.css";
import back from "../../assets/back.svg";
import { useNavigate, useParams } from "react-router-dom";
import { Form, Formik } from "formik";
import { AdminButton } from "../../components/buttons/versionHistoryBtn";

import upload from "../../assets/uploadImg.svg";
import reupload from "../../assets/reUpload.svg";
import InputField from "../../components/form/inputField/inputField";
import * as Yup from "yup";
import ErrorMsg from "../../components/form/errorMsg";
import Select from "react-select";
import { useDispatch } from "react-redux";
import {
  distributorLogoUpload,
  distributorProfile,
} from "../../redux/actions/authActions";
import { distributorEdit } from "../../redux/actions/authActions";
import { fetchDistrictList } from "../../redux/actions/commonActions";
import { fetchCityList } from "../../redux/actions/commonActions";
import { fetchStateList } from "../../redux/actions/commonActions";
import SuccessPopup from "../../components/Popups/SuccessPopUp";
import ErrorPopup from "../../components/Popups/ErrorPopup";
import LoadingSpinnerTable from "../../components/utilites/loader";
import closeIcon from "../../assets/close.png";
import { Spinner } from "react-bootstrap";

const DistributorDetailsEdit = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const params = useParams();
  const [logoImages, setLogoImages] = useState([]); // LOGO IMAGE UPLOAD
  const [distributerProfileData, setDistributerProfileData] = useState([]);
  const [logoImg, setLogoImg] = useState(null);
  const [logoUpldLoading, setLogoUpldLoading] = useState(false);
  const [stateOptions, setStateOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [showSuccessMsg, setShowSuccessMsg] = useState(false);
  const [showErrorPopup, setShowErrorPopup] = useState(false);
  const [showErrorMsg, setShowErrorMsg] = useState("");
  const [loading, setLoading] = useState(false);

  const logoimageUpdate = (e) => {
    setLogoUpldLoading(true);

    dispatch(
      distributorLogoUpload(
        e.target.files[0],
        onLogoUploadSuccess,
        onLogoUploadError
      )
    );
    e.target.files = null;
  };

  const onLogoUploadSuccess = (data) => {
    console.log(data);
    setLogoUpldLoading(false);
    setLogoImg(data.data.data.filePath);
  };
  const onLogoUploadError = (err) => {
    setLogoUpldLoading(false);
    console.log(err);
  };

  useEffect(() => {
    setLoading(true);
    fetchDistributerView();
  }, []);
  const fetchDistributerView = () => {
    dispatch(distributorProfile(params?.id, onViewSuccess, onViewError));
  };

  const onViewSuccess = (data) => {
    setLoading(false);
    console.log(data.data.data);
    setDistributerProfileData(data?.data?.data);
    setSelectedState(data?.data?.data?.state_id);
    setSelectedDistrict(data?.data?.data?.district_id);
    setSelectedCity(data?.data?.data?.city_id);
    setLogoImg(data?.data?.data?.logo);
    setLogoImages([{ data_url: data?.data?.data?.logo }]);
  };

  useEffect(() => {
    console.log("asdas", setSelectedState);
  }, [setSelectedState]);

  const onViewError = (err) => {
    setLoading(false);
    console.log(err);
  };

  useEffect(() => {
    dispatch(fetchStateList(onGetStateSuccess, onGetStateError));
  }, []);

  useEffect(() => {
    if (selectedState !== null) {
      dispatch(
        fetchDistrictList(
          { state_id: selectedState },
          onGetDistrictSuccess,
          onGetDistrictError
        )
      );
    }
  }, [selectedState]);

  useEffect(() => {
    if (selectedState !== null) {
      dispatch(
        fetchDistrictList(
          { state_id: selectedState },
          onGetDistrictSuccess,
          onGetDistrictError
        )
      );
    }
  }, [selectedState]);

  useEffect(() => {
    if (selectedDistrict !== null) {
      dispatch(
        fetchCityList(
          { state_id: selectedState, district_id: selectedDistrict },
          onGetCitySuccess,
          onGetCityError
        )
      );
    } else {
      setCityOptions([]);
    }
  }, [selectedState, selectedDistrict]);

  const onGetStateSuccess = (data) => {
    console.log(data);
    setStateOptions(data);
  };
  const onGetStateError = (err) => {
    console.log(err);
  };

  const onGetDistrictSuccess = (data) => {
    setDistrictOptions(data);
    console.log(data);
  };
  const onGetDistrictError = (err) => {
    console.log(err);
  };

  const onGetCitySuccess = (data) => {
    setCityOptions(data);
    console.log(data);
  };
  const onGetCityError = (err) => {
    console.log(err);
  };

  const initialValues = {
    logo: distributerProfileData?.logo,
    drug_licence_number_20_a: distributerProfileData?.drug_licence_number_20_a,
    drug_licence_number_20_b: distributerProfileData?.drug_licence_number_20_b,
    fssai_number: distributerProfileData?.fssai_number,
    email: distributerProfileData?.email,
    alternate_email: distributerProfileData?.alternate_email,
    mobile: distributerProfileData?.mobile,
    alternate_mobile: distributerProfileData?.alternate_mobile,
    address_one: distributerProfileData?.address?.address_one,
    address_two: distributerProfileData?.address?.address_two,
    address_three: distributerProfileData?.address?.address_three,
    landmark: distributerProfileData?.address?.landmark,
    pincode: distributerProfileData?.pincode,
    state_id: distributerProfileData?.state_id,
    district_id: distributerProfileData?.district_id,
    city_id: distributerProfileData?.city_id,
    districts:
      distributerProfileData?.distributorDistrictCoveredByDistributors?.map(
        (ele) => ele?.district_id
      ),
  };

  const phoneRegex = /^([+]\d{2})?\d{10}$/;
  const pincoderegex = /^[1-9]{1}[0-9]{2}\s{0,1}[0-9]{3}$/;

  const validationSchema = Yup.object().shape({
    drug_licence_number_20_a: Yup.string().required("Required"),
    drug_licence_number_20_b: Yup.string().required("Required"),
    fssai_number: Yup.string().required("Required"),
    email: Yup.string().email("Not a proper email").required("Required"),
    alternate_email: Yup.string().email("Not a proper email").optional(),
    mobile: Yup.string()
      .matches(phoneRegex, "Not a valid Number")
      .required("Required"),
    alternate_mobile: Yup.string()
      .matches(phoneRegex, "Not a valid Number")
      .optional(),
    address_one: Yup.string().required("Required"),
    address_two: Yup.string().optional(),
    address_three: Yup.string().optional(),
    landmark: Yup.string().optional(),
    state_id: Yup.string().required("Required"),
    district_id: Yup.string().required("Required"),
    city_id: Yup.string().required("Required"),
    pincode: Yup.string()
      .matches(pincoderegex, "Not a valid Number")
      .required("Required"),
  });
  const resetFunc = (setFieldValue) => {
    setFieldValue(
      "drug_licence_number_20_a",
      distributerProfileData?.drug_licence_number_20_a
    );
    setFieldValue(
      "drug_licence_number_20_b",
      distributerProfileData?.drug_licence_number_20_b
    );
    setFieldValue("fssai_number", distributerProfileData?.fssai_number);
    setFieldValue("email", distributerProfileData?.email);
    setFieldValue("alternate_email", distributerProfileData?.alternate_email);
    setFieldValue("mobile", distributerProfileData?.mobile);
    setFieldValue("alternate_mobile", distributerProfileData?.alternate_mobile);
    setFieldValue("landmark", distributerProfileData?.address?.landmark);
    setFieldValue("pincode", distributerProfileData?.pincode);
    setFieldValue("address_one", distributerProfileData?.address?.address_one);
    setFieldValue("address_two", distributerProfileData?.address?.address_two);
    setFieldValue(
      "address_three",
      distributerProfileData?.address?.address_three
    );
    setFieldValue("logo", distributerProfileData?.logo);
    setSelectedState(distributerProfileData?.state_id);
    setFieldValue("state_id", distributerProfileData?.state_id);
    setFieldValue("district_id", distributerProfileData?.district_id);
    setFieldValue("city_id", distributerProfileData?.city_id);
    setFieldValue(
      "distributorDistrictCoveredByDistributors",
      distributerProfileData?.distributorDistrictCoveredByDistributors
    );
    setFieldValue(
      "districts",
      distributerProfileData?.distributorDistrictCoveredByDistributors?.map(
        (ele) => ele?.district_id
      )
    );
    setLogoImages([{ data_url: distributerProfileData?.logo }]);
  };
  const onSubmit = (values) => {
    console.log(values);
    values["logo"] = logoImg;
    values["address"] = {
      address_one: values.address_one,
      address_two: values.address_two,
      address_three: values.address_three,
      landmark: values.landmark,
    };
    dispatch(distributorEdit(values, onSuccess, onError));
  };

  const timeOutFnc = () => {
    setShowSuccessPopup(false);
    navigate("/current-orders");
  };

  const onSuccess = (data) => {
    console.log(data);
    setShowSuccessPopup(true);
    setShowSuccessMsg(data.data.message);
    setTimeout(timeOutFnc, 2000);
  };

  const closeErrorPopup = () => {
    setShowErrorPopup(false);
  };

  const onError = (err) => {
    console.log(err);
    setShowErrorPopup(true);
    const str = err.data.message;
    const str_modify = str.charAt(0).toUpperCase() + str.slice(1);
    setShowErrorMsg(str_modify);
  };

  return (
    <>
      <Topnav />
      <>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          enableReinitialize={true}
          onSubmit={onSubmit}
        >
          {({ errors, setFieldValue, values }) => (
            <Form>
              <div className="edit-main-container m-4">
                <div
                  style={{ borderBottom: "1px solid #E7E5FF" }}
                  className="d-flex justify-content-between"
                >
                  <div
                    className="d-flex align-items-center p-2 ms-3 m-1 mb-2 cursor_pointer"
                    onClick={() => navigate(-1)}
                  >
                    <img src={back} alt="back_btn" />
                    <span className="px-2 dark_grey_color fs_16 fn_Nunito fw_600">
                      BACK
                    </span>
                  </div>
                  <div className=" d-flex justify-content-between m-1 mb-2">
                    <AdminButton
                      background="#E7E5FF"
                      width="100px"
                      color="#7065E4"
                      onClick={() => resetFunc(setFieldValue)}
                      type="button"
                    >
                      RESET
                    </AdminButton>
                    <AdminButton
                      background="#7065E4"
                      color="white"
                      width="100px"
                      type="submit"
                    >
                      <span className="m-2">SAVE</span>
                    </AdminButton>
                  </div>
                </div>
                <div style={{ position: "relative" }}>
                  {loading == true ? (
                    <div className="list-spinner-container">
                      <LoadingSpinnerTable />
                    </div>
                  ) : (
                    <div className="scrolling fn_Nunito">
                      <>
                        <div className="basic-details-container my-3 mt-4 mx-4 my-auto d-flex align-items-center">
                          <label className="basic-title mx-2 mb-1">
                            Basic Details
                          </label>
                        </div>
                        <div className="row mt-3 ms-5">
                          <div className="col-md-6">
                            <div
                              className="mx-md-4 px-3 mx-auto"
                              style={{ maxWidth: "480px" }}
                            >
                              <div className="my-2">
                                <div
                                  className="d-flex justify-content-between"
                                  style={{ maxWidth: "450px" }}
                                >
                                  <label className="color_747f9e fs_14">
                                    Distributor Logo
                                  </label>

                                  {logoImg && (
                                    <label htmlFor="logoUpdate">
                                      <img src={reupload} />
                                      <span className=" ms-1 fs_12 fw_700 Medium_Purple cursor_pointer">
                                        RE-UPLOAD
                                      </span>
                                    </label>
                                  )}
                                  <input
                                    id="logoUpdate"
                                    className="upload-document-input position-absolute"
                                    type="file"
                                    name="file"
                                    onChange={(e) => logoimageUpdate(e)}
                                  />
                                </div>

                                {logoImg ? (
                                  <div className="logo-upload-container position-relative">
                                    <div
                                      onClick={() => setLogoImg(null)}
                                      className={`upload_icon_close_container position-absolute top-0 end-0 m-1`}
                                    >
                                      <img
                                        src={closeIcon}
                                        alt="close icon"
                                        width={20}
                                        height={20}
                                        className={`cursor_pointer mb-2  `}
                                      />
                                    </div>
                                    <img
                                      className="logo-upload-container"
                                      src={logoImg}
                                      alt="logo"
                                    />
                                  </div>
                                ) : (
                                  <div className="logo-upload-container">
                                    {logoUpldLoading ? (
                                      <div className="d-flex justify-content-center align-items-center h-100">
                                        <Spinner size="sm" />
                                      </div>
                                    ) : (
                                      <label
                                        htmlFor="logoUpdate"
                                        className={`h-100 d-flex flex-column align-items-center justify-content-around p-2`}
                                      >
                                        <div
                                          className={`d-flex flex-column align-items-center justify-content-center `}
                                        >
                                          <img
                                            src={upload}
                                            width="50px"
                                            height="50px"
                                          />
                                          <span className="color_#262C3D pt-2 fs_14 fs_lg_12">
                                            Drag your image here, or
                                            <span className="Medium_Purple fw_700 ms-1">
                                              Browse
                                            </span>
                                          </span>
                                          <label className="color_747f9e pt-1 fs_10">
                                            Supports: JPEG and PNG images only.{" "}
                                            <span className="color_262c3d">
                                              (2MB Max, 540X540px Resolution)
                                            </span>
                                          </label>
                                          <input
                                            id="logoUpdate"
                                            className="upload-document-input"
                                            type="file"
                                            name="file"
                                            // accept="pdf/*"
                                            onChange={(e) => logoimageUpdate(e)}
                                          />
                                        </div>
                                      </label>
                                    )}
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div
                              className="mx-md-4 px-3 mx-auto"
                              style={{ maxWidth: "480px" }}
                            >
                              <div className="my-2">
                                <InputField
                                  id={"drug_licence_number_20_a"}
                                  label={"Drug Licence 1"}
                                  labelColor="color_747f9e"
                                  type={"text"}
                                  placeholder={"Enter drug licence number 1"}
                                  name={"drug_licence_number_20_a"}
                                  value={values?.drug_licence_number_20_a}
                                />
                              </div>
                              <div className="my-2">
                                <InputField
                                  id={"drug_licence_number_20_b"}
                                  label={"Drug Licence 2"}
                                  labelColor="color_747f9e"
                                  type={"text"}
                                  placeholder={"Enter drug licence number 2"}
                                  name={"drug_licence_number_20_b"}
                                  value={values?.drug_licence_number_20_b}
                                />
                              </div>
                              <div className="my-2">
                                <InputField
                                  id={"fssai_number"}
                                  label={"FSSAI Number"}
                                  labelColor="color_747f9e"
                                  type={"text"}
                                  placeholder={"Enter FSSAI number"}
                                  name={"fssai_number"}
                                  value={values?.fssai_number}
                                />
                              </div>
                              <div className="my-2">
                                <div className="select-container">
                                  <label className="w-100 mx-1 fn_Nunito fs_14 color_747f9e">
                                    District Covered
                                  </label>

                                  <Field name={"districts"}>
                                    {({ form, Field }) => (
                                      <Select
                                        isMulti
                                        options={districtOptions}
                                        styles={customStyles}
                                        {...Field}
                                        placeholder={"Enter your district"}
                                        id="districts"
                                        value={districtOptions.filter((d1) =>
                                          values?.districts?.some(
                                            (d2) => d2 == d1.value
                                          )
                                        )}
                                        onChange={(selectedOption) => {
                                          let newArr = values.districts;
                                          form.setFieldValue(
                                            "districts",
                                            selectedOption
                                              ? selectedOption.map(
                                                  (item) => item.value
                                                )
                                              : newArr
                                          );
                                        }}
                                      />
                                    )}
                                  </Field>
                                  <ErrorMsg name="districts" />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                      <div className="basic-details-container my-3 mt-4 mx-4 my-auto d-flex align-items-center ">
                        <label className="basic-title mx-2 mb-1">
                          Contact Details
                        </label>
                      </div>
                      <div className="row mt-3 ms-5">
                        <div className="col-md-6">
                          <div
                            className="mx-md-4 px-3 mx-auto"
                            style={{ maxWidth: "480px" }}
                          >
                            <div className="my-2">
                              <InputField
                                id={"email"}
                                label={"Email Address"}
                                labelColor="color_747f9e"
                                type={"text"}
                                placeholder={"Enter email address"}
                                name={"email"}
                                value={values?.email}
                                disabled={true}
                              />
                            </div>
                            <div className="my-2">
                              <InputField
                                id={"alternate_email"}
                                label={"Alternate Email Address"}
                                labelColor="color_747f9e"
                                type={"text"}
                                placeholder={"Enter alternate email address"}
                                name={"alternate_email"}
                                value={values?.alternate_email}
                              />
                            </div>
                            <div className="my-2">
                              <InputField
                                id={"mobile"}
                                label={"Mobile Number"}
                                labelColor="color_747f9e"
                                type={"text"}
                                placeholder={"Enter mobile number"}
                                name={"mobile"}
                                value={values?.mobile}
                                maxLength={10}
                                disabled={true}
                              />
                            </div>
                            <div className="my-2">
                              <InputField
                                id={"alternate_mobile"}
                                label={"Alternative Mobile Number"}
                                labelColor="color_747f9e"
                                type={"text"}
                                placeholder={"Enter alternative mobile number"}
                                name={"alternate_mobile"}
                                value={values?.alternate_mobile}
                                maxLength={10}
                              />
                            </div>
                            <div className="my-2">
                              <label className="w-100 mx-1 fn_Nunito fs_14 color_747f9e">
                                Address
                              </label>
                              <div>
                                <Field name={"address_one"}>
                                  {({ field, meta }) => (
                                    <input
                                      {...field}
                                      placeholder="Address line 1"
                                      id={"address_one"}
                                      className={
                                        "w-100 input input-field py-2 my-1"
                                      }
                                    />
                                  )}
                                </Field>
                                <Field name={"address_two"}>
                                  {({ field, meta }) => (
                                    <input
                                      {...field}
                                      placeholder="Address line 2"
                                      id={"address_two"}
                                      className={
                                        "w-100 input input-field py-2 my-1"
                                      }
                                    />
                                  )}
                                </Field>
                                <Field name={"address_three"}>
                                  {({ field, meta }) => (
                                    <input
                                      {...field}
                                      placeholder="Address line 3"
                                      id={"address_three"}
                                      className={
                                        "w-100 input input-field py-2 my-1"
                                      }
                                    />
                                  )}
                                </Field>
                                {(errors.address_one && (
                                  <ErrorMsg name={"address_one"} />
                                )) ||
                                  (errors.address_two && (
                                    <ErrorMsg name={"address_two"} />
                                  )) ||
                                  (errors.address_three && (
                                    <ErrorMsg name={"address_three"} />
                                  ))}
                              </div>
                            </div>
                            <div className="my-2">
                              <InputField
                                id={"landmark"}
                                label={"Landmark"}
                                labelColor="color_747f9e"
                                type={"text"}
                                placeholder={"Enter landmark"}
                                name={"landmark"}
                                value={values?.landmark}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div
                            className="mx-md-4 px-3 mx-auto"
                            style={{ maxWidth: "480px" }}
                          >
                            <div>
                              <InputField
                                id={"pincode"}
                                label={"Pincode"}
                                labelColor="color_747f9e"
                                type={"text"}
                                placeholder={"Enter pincode"}
                                name={"pincode"}
                                value={values?.pincode}
                              />
                            </div>
                            <div className="select-container">
                              <label className="w-100 mx-1 fn_Nunito fs_14 color_747f9e">
                                State
                              </label>
                              <Field name={"state_id"}>
                                {({ field, meta }) => (
                                  <Select
                                    {...field}
                                    options={stateOptions}
                                    styles={customStyles}
                                    placeholder={"Enter your state"}
                                    value={stateOptions.filter(
                                      (s) => s.value == values.state_id
                                    )}
                                    onChange={(selected) => {
                                      setSelectedState(selected?.value);
                                      setFieldValue(
                                        "state_id",
                                        selected?.value
                                      );
                                    }}
                                  />
                                )}
                              </Field>
                              <ErrorMsg name="state_id" />
                            </div>
                            <div className="select-container">
                              <label className="w-100 mx-1 fn_Nunito fs_14 color_747f9e">
                                District
                              </label>
                              <Field name={"district_id"}>
                                {({ field, meta }) => (
                                  <Select
                                    {...field}
                                    options={districtOptions}
                                    styles={customStyles}
                                    placeholder={"Enter your district"}
                                    value={districtOptions.filter(
                                      (s) => s.value == values.district_id
                                    )}
                                    onChange={(selected) => {
                                      setSelectedDistrict(selected?.value);
                                      setFieldValue(
                                        "district_id",
                                        selected?.value
                                      );
                                    }}
                                  />
                                )}
                              </Field>
                              <ErrorMsg name="district_id" />
                            </div>
                            <div className="select-container">
                              <label className="w-100 mx-1 fn_Nunito fs_14 color_747f9e">
                                City
                              </label>
                              <Field name={"city_id"}>
                                {({ field, meta }) => (
                                  <Select
                                    {...field}
                                    options={cityOptions}
                                    styles={customStyles}
                                    placeholder={"Enter your city"}
                                    value={cityOptions.filter(
                                      (s) => s.value == values.city_id
                                    )}
                                    onChange={(selected) => {
                                      setSelectedCity(selected?.value);
                                      setFieldValue("city_id", selected?.value);
                                    }}
                                  />
                                )}
                              </Field>
                              <ErrorMsg name="city_id" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Form>
          )}
        </Formik>
        <SuccessPopup show={showSuccessPopup} title={showSuccessMsg} />
        <ErrorPopup
          show={showErrorPopup}
          title={showErrorMsg}
          handleClose={closeErrorPopup}
        />
      </>
    </>
  );
};

export default DistributorDetailsEdit;

export const customStyles = {
  indicatorSeparator: () => ({ display: "none" }),
  control: (base, state) => ({
    ...base,
    border: "1px solid #B0B3C7",
    color: "#464646",
    fontFamily: "Nunito Sans",
    fontWeight: "400",
    fontSize: "15px",
    borderRadius: "8px",
    width: "100%",
    maxWidth: "450px",
    // height: "40px",
    boxShadow: state.isFocused ? null : null,
    "&:hover": {},
  }),
  placeholder: (defaultStyles) => {
    return {
      ...defaultStyles,
      color: "#B0B3C7",
      fontSize: "14px",
      fontFamily: "Nunito Sans",
    };
  },
  dropdownIndicator: (base) => ({
    ...base,
    color: "#a9a3e3", // Custom colour
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected ? "#E7E5FF" : null,
    color: "#00000",
    // fontFamily: "Nunito",
    "&:hover": {
      backgroundColor: state.isFocused ? "#E7E5FF" : "#E7E5FF",
    },
  }),
};
